import { render, staticRenderFns } from "./MLsportEuropeanCart.vue?vue&type=template&id=20005a9b&scoped=true"
import script from "./MLsportEuropeanCart.vue?vue&type=script&lang=js"
export * from "./MLsportEuropeanCart.vue?vue&type=script&lang=js"
import style0 from "./MLsportEuropeanCart.vue?vue&type=style&index=0&id=20005a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20005a9b",
  null
  
)

export default component.exports